var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMidPlanetResponsiveRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 669,
    height: 221,
    viewBox: "0 0 669 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.299 187.033C64.8493 187.033 18.2318 191.188 1.59886 218.155C0.814898 219.426 1.77012 221 3.26347 221H214.918C216.366 221 217.326 219.502 216.654 218.219C199.125 184.745 150.049 187.033 107.299 187.033Z",
    fill: "#2F462F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M481.063 221L320.982 61L161 221H481.063Z",
    fill: "#586753"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336 75.6025L320.653 60L304 76.9303C304.98 77.3729 305.85 77.7049 307.156 77.7049C308.245 77.7049 309.224 77.373 309.986 77.041C310.966 78.2582 312.272 78.9221 313.905 78.9221H314.014C314.014 79.2541 314.014 79.3648 314.014 79.6967C314.014 83.6803 317.17 87 321.197 87C325.116 87 328.381 83.791 328.381 79.6967C328.381 79.2541 328.381 78.9221 328.272 78.4795C328.925 78.5902 329.687 78.8115 330.449 78.8115C332.408 78.7008 334.585 77.4836 336 75.6025Z",
    fill: "#F1E8E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M669 221L461.409 1L253.918 221H669Z",
    fill: "#BFC8B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M493 33.3823L461.72 0L429 34.9374C430.646 35.5594 432.807 35.8704 434.865 35.8704C436.923 35.8704 438.878 35.5594 440.627 34.9374C442.273 36.4924 445.154 37.5292 448.241 37.5292C448.344 37.5292 448.344 37.5292 448.55 37.5292C448.55 37.8402 448.447 38.1512 448.447 38.5659C448.447 43.7495 454.826 48 462.749 48C470.672 48 477.051 43.8531 477.051 38.5659C477.051 38.0475 476.949 37.4255 476.743 36.9071C478.08 37.2181 479.418 37.3218 481.064 37.3218C485.797 37.3218 490.222 35.7667 493 33.3823Z",
    fill: "#F1E8E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M424.252 87.9001C424.252 86.0001 422.652 84.4001 420.751 84.4001H420.651C420.751 84.1001 420.751 83.8001 420.751 83.5001C420.751 81.6001 419.151 80.0001 417.251 80.0001C416.351 80.0001 415.55 80.3001 414.95 80.9001C413.75 79.3001 411.85 78.3 409.749 78.3C406.149 78.3 403.148 81.3001 403.148 84.9001C403.148 88.5001 406.149 91.5001 409.749 91.5001C410.149 91.5001 410.449 91.5001 410.849 91.4001H421.151C422.852 91.1001 424.252 89.7001 424.252 87.9001Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M426.052 221C420.929 198.094 397.321 180.79 368.991 180.79C340.661 180.79 317.053 197.994 312.03 221H426.052Z",
    fill: "#F3DABE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M381.083 169.69C381.116 164.663 378.399 160.57 375.015 160.548C371.63 160.525 368.86 164.582 368.827 169.609C368.794 174.636 371.51 178.73 374.895 178.752C378.279 178.774 381.05 174.717 381.083 169.69Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M375.018 166.887L374.918 188.292",
    stroke: "#2F462F",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M372.507 170.388L375.119 171.288",
    stroke: "#2F462F",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M375.019 173.188L378.132 172.188",
    stroke: "#2F462F",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M372.406 174.089L375.118 174.989",
    stroke: "#2F462F",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M375.019 168.387L378.233 167.387",
    stroke: "#2F462F",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M372.507 169.288L375.119 170.188",
    stroke: "#2F462F",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M349.432 180.732C353.331 179.866 355.051 172.738 353.274 164.812C351.498 156.886 346.897 151.164 342.998 152.031C339.099 152.898 337.379 160.025 339.156 167.951C340.932 175.877 345.533 181.599 349.432 180.732Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M345.282 161.986L352.817 195.694",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M343.574 168.087L346.989 168.787",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M347.492 171.788L350.807 169.388",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M344.88 173.989L348.295 174.589",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M345.885 164.286L349.099 161.886",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M343.173 166.387L346.588 167.087",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M409.042 162.42C410.147 155.044 406.683 148.416 401.305 147.618C395.927 146.819 390.671 152.151 389.567 159.528C388.462 166.904 391.927 173.531 397.305 174.33C402.683 175.129 407.938 169.796 409.042 162.42Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M400.032 156.885L395.01 194.694",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M395.211 161.486L399.228 163.386",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M398.727 166.087L403.951 165.387",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M394.407 166.887L398.425 168.787",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M399.731 159.085L404.955 158.385",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M395.411 159.885L399.429 161.785",
    stroke: "#2F462F",
    strokeWidth: 0.6598,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M395.992 143.547C396.909 131.706 394.423 121.859 390.44 121.553C386.458 121.248 382.486 130.599 381.57 142.441C380.653 154.282 383.139 164.129 387.122 164.435C391.104 164.74 395.076 155.389 395.992 143.547Z",
    fill: "#2F462F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M389.383 136.38L385.466 186.792",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M385.667 144.382L388.681 146.682",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M388.279 151.183L392.196 149.083",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M384.964 153.084L387.977 155.384",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M389.083 139.88L393 137.78",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M385.868 141.881L388.881 144.081",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M363.672 161.489C368.222 161.466 371.865 152.67 371.81 141.843C371.755 131.015 368.022 122.257 363.473 122.28C358.923 122.303 355.28 131.099 355.335 141.926C355.39 152.754 359.123 161.512 363.672 161.489Z",
    fill: "#2F462F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M363.566 135.88L363.766 182.091",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M360.15 143.481L363.766 145.281",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M363.666 149.382L367.885 147.182",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M360.25 151.383L363.866 153.283",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M363.666 138.98L367.885 136.78",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M360.15 141.081L363.766 142.881",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M329.911 186.028C333.447 185.707 335.601 177.642 334.721 168.015C333.841 158.387 330.261 150.842 326.724 151.163C323.188 151.483 321.035 159.548 321.915 169.176C322.795 178.803 326.375 186.348 329.911 186.028Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M327.802 163.186L331.519 204.296",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M331.117 169.688L328.405 171.588",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M328.907 175.189L325.391 173.589",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M331.72 176.789L329.108 178.689",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M328.002 165.986L324.487 164.386",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M330.916 167.587L328.204 169.487",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M408.487 189.993C412.426 189.987 415.613 185.281 415.605 179.48C415.597 173.68 412.397 168.982 408.458 168.988C404.519 168.993 401.332 173.7 401.34 179.5C401.348 185.301 404.548 189.998 408.487 189.993Z",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M408.472 176.289L408.572 211.598",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M405.558 180.39L408.672 181.39",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M408.572 183.591L412.188 182.391",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M405.558 184.691L408.672 185.691",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M408.572 177.989L412.188 176.789",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M405.558 179.09L408.672 180.09",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M581.283 47.3001C581.283 43.9001 578.482 41.1001 575.082 41.1001H574.982C575.082 40.6001 575.282 40.0001 575.282 39.5001C575.282 36.1001 572.481 33.3001 569.08 33.3001C567.48 33.3001 566.08 33.9001 564.88 34.9001C562.779 32.1001 559.479 30.2001 555.678 30.2001C549.377 30.2001 544.176 35.4001 544.176 41.7001C544.176 48.0001 549.377 53.2001 555.678 53.2001H575.882C578.882 53.0001 581.283 50.4001 581.283 47.3001Z",
    fill: "#754C4E",
    stroke: "white",
    strokeWidth: 0.674,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M306 98.2C306 95 303.4 92.4 300.2 92.4C298.8 92.4 297.5 92.9 296.5 93.8C296.2 90.9 293.8 88.6 290.7 88.6C290 88.6 289.3 88.7 288.6 89C288.6 88.7 288.6 88.4 288.6 88.1C288.6 82.5 284.1 78 278.5 78C276.2 78 274.1 78.8 272.4 80C270.2 71.9 262.8 66 254.1 66C243.6 66 235.1 74.5 235.1 85V85.1C233.6 84.2 231.9 83.7 230.1 83.7C224.5 83.7 220 88.2 220 93.8C220 99.4 224.5 103.9 230.1 103.9C230.1 103.9 230.1 103.9 230.2 103.9H300.4C303.5 103.9 306 101.3 306 98.2Z",
    fill: "#A98E91",
    stroke: "white",
    strokeWidth: 0.674,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidPlanetResponsiveRight);
export default __webpack_public_path__ + "static/media/mid_planet_responsive-right.d049678e77a8d6af76381de572c0d8a5.svg";
export { ForwardRef as ReactComponent };